import { ProfileGuideComponent } from './dashboard/profile-guide/profile-guide.component';
import { DashboardStatisticsComponent } from './dashboard/dashboard-statistics/dashboard-statistics.component';
import { ManageApplicationsComponent } from './dashboard/manage-applications/manage-applications.component';
import { PersonalInfoComponent } from './dashboard/personal-info/personal-info.component';
import { WorkExperienceComponent } from './dashboard/work-experience/work-experience.component';
import { UploadsComponent } from './dashboard/uploads/uploads.component';
import { RefereeComponent } from './dashboard/referee/referee.component';
import { EducationalInfoComponent } from './dashboard/educational-info/educational-info.component';
import { UserProfileComponent } from './dashboard/user-profile/user-profile.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { VacanciesCategoryComponent } from './vacancies-category/vacancies-category.component';
import { JobListingComponent } from './job-listing/job-listing.component';
import { JobApplicationComponent } from './job-application/job-application.component';
import { RegisterComponent } from './auth/register/register.component';
import { LoginComponent } from './auth/login/login.component';
import { MainLayoutComponent } from './layout-components/main-layout/main-layout.component';
import { AuthGuard } from './_helpers';
import { EliminationFormComponent } from '../app/elimination-form/elimination-form.component';
import { ViewPdfComponent } from './dashboard/view-pdf/view-pdf.component';
import { UpdatePasswordComponent } from './auth/update-password/update-password.component';
import { PasswordResetComponent } from './auth/password-reset/password-reset.component';
import { ForgetPasswordComponent } from './auth/forget-password/forget-password.component';
import { BrowseApplicationComponent } from './browse-application/browse-application.component';
import { VerificationCodeComponent } from './auth/verification-code/verification-code.component';
import { CvComponent } from './dashboard/cv/cv.component';
import { CharterComponent } from './charter/charter.component';

const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: VacanciesCategoryComponent,
      },
    ],
  },
  {
    path: 'charter',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: CharterComponent,
      },
    ],
  },
  {
    path: 'vacancies/list/:departmentId',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: JobListingComponent,
      },
    ],
  },

  {
    path: 'job-details/:vacantId',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: JobApplicationComponent,
      },
    ],
  },
  {
    path: 'dashboard/profile',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: UserProfileComponent,
      },
    ],
    canActivate: [AuthGuard],
  },
  {
    path: 'dashboard/personal-info',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: PersonalInfoComponent,
      },
    ],
    canActivate: [AuthGuard],
  },
  {
    path: 'dashboard/educational-info',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: EducationalInfoComponent,
      },
    ],
    canActivate: [AuthGuard],
  },
  {
    path: 'dashboard/referee',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: RefereeComponent,
      },
    ],
    canActivate: [AuthGuard],
  },
  {
    path: 'dashboard/uploads',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: UploadsComponent,
      },
    ],
    canActivate: [AuthGuard],
  },

  {
    path: 'dashboard/cvs',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: CvComponent,
      },
    ],
    canActivate: [AuthGuard],
  },
  {
    path: 'dashboard/work-experience',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: WorkExperienceComponent,
      },
    ],
    canActivate: [AuthGuard],
  },
  {
    path: 'dashboard/manage-applications',
    component: AppComponent,
    children: [
      {
        path: '',
        component: ManageApplicationsComponent,
      },
    ],
    canActivate: [AuthGuard],
  },
  {
    path: 'dashboard/dashboard-statistics',
    component: AppComponent,
    children: [
      {
        path: '',
        component: DashboardStatisticsComponent,
      },
    ],
    canActivate: [AuthGuard],
  },
  {
    path: 'dashboard/profile-guide',
    component: AppComponent,
    children: [
      {
        path: '',
        component: ProfileGuideComponent,
      },
    ],
    canActivate: [AuthGuard],
  },
  {
    path: 'dashboard/dashboard-statistics',
    component: AppComponent,
    children: [
      {
        path: '',
        component: DashboardStatisticsComponent,
      },
    ],
    canActivate: [AuthGuard],
  },
  {
    path: 'dashboard/view-pdf',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: ViewPdfComponent,
      },
    ],
    canActivate: [AuthGuard],
  },
  {
    path: 'dashboard/browse-vacant/:vacantId',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: BrowseApplicationComponent,
      },
    ],
    canActivate: [AuthGuard],
  },
  {
    path: 'update-password',
    component: MainLayoutComponent,
    children: [{ path: '', component: UpdatePasswordComponent }],
    canActivate: [AuthGuard],
  },
  {
    path: 'register',
    component: MainLayoutComponent,
    children: [{ path: '', component: RegisterComponent }],
  },
  {
    path: 'elimination-form',
    component: MainLayoutComponent,
    children: [{ path: '', component: EliminationFormComponent }],
  },
  {
    path: 'login',
    component: MainLayoutComponent,
    children: [{ path: '', component: LoginComponent }],
  },
  {
    path: 'forget-password',
    component: MainLayoutComponent,
    children: [{ path: '', component: ForgetPasswordComponent }],
  },
  {
    path: 'password-reset',
    component: MainLayoutComponent,
    children: [{ path: '', component: PasswordResetComponent }],
  },
  {
    path: 'activate-account',
    component: MainLayoutComponent,
    children: [{ path: '', component: VerificationCodeComponent }],
  },
  {
    path: '**',
    redirectTo: '',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}

export const routingComponents = [
  AppComponent,
  VacanciesCategoryComponent,
  JobListingComponent,
  JobApplicationComponent,
  RegisterComponent,
  LoginComponent,
  UpdatePasswordComponent,
  UserProfileComponent,
  EducationalInfoComponent,
  RefereeComponent,
  ManageApplicationsComponent,
  DashboardStatisticsComponent,
  ProfileGuideComponent,
  ViewPdfComponent,
  PasswordResetComponent,
  ForgetPasswordComponent,
  CharterComponent,
];
